import { observable } from 'mobx';

class UsersGridStore {

    @observable filteredUsers;
    @observable selectedPage = 1;
    @observable rowsPerPage = 10;
    @observable filterTeams;
    @observable filterRoles;
    @observable filteredUserStatus;
    @observable searchData;
    @observable selectedRows = [];
    @observable lastLoginOver;
    @observable creationDateOver;

}

export default new UsersGridStore();